import { ChangeEvent } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { InputType } from "reactstrap/types/lib/Input";
import { CardSubtitle } from "./CoreComponents";

export interface FormInputs {
  firstName: string;
  lastName: string;
  username: string;
  city: string;
  state: string;
  zip: string;
  password: string;
  file: string;
  description: string;
}

export interface RadioPayProps {
  colClass: string;
}

export interface InputProps {
  colClass?: string;
  id?: string;
  placeholder?: string;
  required?: boolean;
  title?: string;
  inputType?: InputType;
  formGroup?: boolean;
  floating?: boolean;
  groupClass?: string;
  labelClass?: string;
  inputClass?: string;
}

export interface SelectOptions {
  value: string;
  label: string;
}

export interface SelectProps {
  colClass?: string;
  id?: string;
  title?: string;
  data: SelectOptions[];
  labelClass?: string;
  inputClass?: string;
}

export interface CheckboxProps {
  id?: string;
  labelClass?: string;
  inputType: InputType;
  required?: boolean;
  title: string;
  name?: string;
  check?: boolean;
  inputClass?: string;
}

export interface SelectDropdownProps {
  inputClass?: string;
  options: string[];
  title: string;
  multiple?: boolean;
  optionClass?: string;
}

export interface OpenMenuProps {
  inputId: string;
  colClass: string;
  options: string[];
}

export interface CheckboxItem {
  id: string;
  labelText: string;
  check?: string;
  disabled?: string;
  groupClass?: string;
  name?: string;
}

export interface FormGroupsItem {
  id: number;
  title: string;
  child: CheckboxItem[];
}

export interface InlineCheckbox {
  id: number;
  type: "checkbox";
  check?: string;
  disabled?: string;
  text: string;
  formGroupClass?: string;
}

export interface InlineRadio {
  id: number;
  type: "radio";
  check?: string;
  disabled?: string;
  name: string;
  text: string;
  formGroupClass?: string;
}

export interface InlineInput {
  id: number;
  title: string;
  child: (InlineCheckbox | InlineRadio)[];
}

export interface CardFooterProps {
  footerClass?: string;
  color1: string;
  btn2Class?: string;
  btn1Class?: string;
  color2: string;
}

export interface StepperProp {
  step: number;
  finishClicked: boolean;
}

export interface BasicFormItems {
  email: string;
  firstName: string;
  password: string;
  confirmPassword: string;
  agreeTerms: boolean;
  placeHolderName: string;
  cardNumber: string;
  expiration: string;
  cvvNumber: string;
  uploadDocumentation: string;
  informationCheckBox: boolean;
  linkedInLink: string;
  gitHubLink: string;
  giveFeedBack: string;
  state: string;
  agreeConditions: boolean;
}

export interface InfoFormProps {
  updateFormData: (event: ChangeEvent<HTMLInputElement>) => void;
  formData: BasicFormItems;
  register: UseFormRegister<BasicFormItems>;
  errors: FieldErrors<BasicFormItems>;
}

export interface StudentForm {
  password: string;
  name: string;
  email: string;
  confirmPassWord: string;
  portfolioURL: string;
  projectDescription: string;
  twitterUrl: string;
  gitHubUrl: string;
  positionQuestion: string;
  positions: string;
  studentFile: string;
  imageUpload: string;
}
export interface StudentFormProp {
  updateFormData: (event: ChangeEvent<HTMLInputElement>) => void;
  formData: StudentForm;
  selectedImage?: string | null;
  register: UseFormRegister<StudentForm>;
  errors: FieldErrors<StudentForm>;
}

export interface WizardForm {
  firstName: string;
  lastName: string;
  email: string;
  contact: string;
  state: string;
  zip: string;
  recipientUserName: string;
  userName: string;
  cardNumber: string;
  expirationDate: string;
  cvvNumber: string;
  documentationName: string;
  bankName: string;
  feedBack: string;
}

export interface WizardFormProps {
  updateFormData: (event: ChangeEvent<HTMLInputElement>) => void;
  formData: WizardForm;
  register: UseFormRegister<WizardForm>;
  errors: FieldErrors<WizardForm>;
}

export interface SwitchItem {
  id: number;
  color: string;
  disabled?: string;
}

export interface CustomSwitchItem {
  id: number;
  cardClass?: string;
  formSize?: string;
  child: SwitchItem[];
}

export interface IconSwitchItem {
  id: number;
  mediaBodyClass?: string;
  color: string;
  labelText: string;
}

export interface IconsUncheckedProp {
  id: number;
  title: string;
  subTitle: CardSubtitle[];
  child: IconSwitchItem[];
}

export interface SwitchChild {
  id: number;
  labelText: string;
  size?: string;
  check?: string;
  disabled?: string;
  spanClass?: string;
}

export interface SwitchIcons {
  id: number;
  title: string;
  subTitle: CardSubtitle[];
  child: SwitchChild[];
}

export interface TypeAheadProps {
  title: string;
  subTitle: CardSubtitle[];
  options: string[] | OptionItems[];
  placeholder: string;
  labelKey?: string;
  className?: string;
  id: string;
}

export interface OptionItems {
  name: string;
  header?: boolean;
  divider?: boolean;
}

export interface WizardProps {
  title: string;
  divClass?: string;
  navColClass: string;
  tabColClass: string;
  differentId?: boolean;
}

export interface WizardNavProps {
  activeCallBack: (tab: number) => void;
  steps: number;
  differentId?: boolean;
}

export interface ActiveCallbackProp {
  activeCallBack: (tab: number) => void;
  differentId?: boolean;
}

export interface NewAddressProps {
  toggle: () => void;
  showModal: boolean;
}

export interface RadioBox {
  address: string;
  shippingMethod: string;
}
export interface ShippingProps {
  handleNextButton?: () => void;
  handleBackButton?: () => void;
  radioBoxValues: RadioBox;
  updateFormData: (event: ChangeEvent<HTMLInputElement>) => void;
}

export interface PaymentProps {
  payMethod: string;
  updateFormData: (event: ChangeEvent<HTMLInputElement>) => void;
  differentId?: boolean;
}

export interface FirstModalProps {
  toggle: () => void;
  modalOne: boolean;
  initialData: string | null;
}

export interface SecondModalProps {
  toggle2: () => void;
  modal2: boolean;
}

export enum CalendarItem {
  DateTimeLocal = "datetime-local",
  Date = "date",
  Month = "month",
  Week = "week",
  Time = "time",
}

export interface ReactstrapCalendar {
  id: number;
  labelText: string;
  type: CalendarItem;
  value: string;
}

export interface TouchSpinProp {
  color: string;
  arrowIcon?: boolean;
  outline?: boolean;
  btnClass?: string;
}

export interface PreAndPostfixProp {
  postIcon?: boolean;
  preIcon?: boolean;
  preButton?: boolean;
  PostButton?: boolean;
  color?: boolean;
}
export interface CustomFormProps {
  inputId: string;
  options: string[];
  title: string;
}

export interface ButtonListProps {
  color: string;
  title?: string;
  options: string[];
  outline?: boolean;
  divider?: boolean;
  split?: boolean;
  span?: boolean;
}

export interface StarItem {
  id: number;
  icon: string;
  class?: string;
}

export interface ChildFormItem {
  id: number;
  color: string;
  name: string;
  mediaBodyClass?: string;
  badgeTitle: string;
  digits: string;
  spanClass?: string;
  star?: StarItem[];
  spanText: string;
  colClass?: string;
  cardClass?: string;
  check?: string;
}

export interface VerticalStyle {
  id: number;
  megaTitle: string;
  child: ChildFormItem[];
}

export interface RadioOption {
  id: number;
  labelText: string;
  image?: string;
  check?: string;
  name: string;
  icon?: string;
  iconColor?: string;
}

export interface RadioItem {
  id: number;
  title: string;
  child: RadioOption[];
}

export interface MultipleItems {
  name: string;
  header?: boolean;
  divider?: boolean;
}

export interface BillingFormData {
  firstName: string;
  lastName: string;
  email: string;
  contact: string;
  address: string;
  country: string;
  state: string;
  zip: string;
  agreeTerms: boolean;
  otherNotes: string;
}

export interface BankFormData {
  aadhaarNumber: string;
  panNumber: string;
  bankName: string;
}

export interface InquiriesFormData {
  notifications: string;
  email: string;
  contactNumber: string;
  describeIssue: string;
}
export enum PayDetailsFormType {
  cardHolderName = "cardHolderName",
  cardNumber = "cardNumber",
  expiryDate = "expiryDate",
  expiryYear = "expiryYear",
  cvvNumber = "cvvNumber",
  agreeTerms = "agreeTerms"
}

export enum BusinessSettingsFormType {
  accountName = "accountName",
  email = "email",
  description = " description",
}
export enum ContactsDetailsFormType {
  organizationName = "organizationName",
  email = "email",
  description = "description",
  organizationType = "organizationType",
}
export interface VariationCheckBox {
  id: number;
  text: string;
  sales?: string;
  check?: string;
  color?: string;
}

export interface RadioListItem {
  id: number | string;
  color?: string;
  check?: string;
  text?: string;
  icon?: string;
  title?: string;
  image?: string;
  disabled?: string;
}

export interface CheckBoxList {
  id: number | string;
  icon?: string;
  title?: string;
  image?: string;
  check?: string;
  disabled?: string;
  text?: string;
}

export interface StyleFormList {
  id?: number;
  color?: string;
  image?: string;
  spanText?: string;
  check?: string;
  badgeTitle?: string;
  digits?: string;
  text?: string;
}

//Form Layout
export interface ModalOneItems {
  icon: string;
  title: string;
  description: string;
}

export interface NavItems {
  id: number;
  icon?: string;
  title: string;
  subTitle?: string;
}

export interface FormBanking {
  id: number;
  bankList: string[];
}

export interface CartTableFooter {
  footerTittle: string;
  price: string;
}

export interface CartTableBody {
  imagePath: string;
  productName: string;
  productSum: string;
  price: string;
}

export interface AddressItems {
  value: string;
  label: string;
  name?: string;
  address?: string;
  contact?: string;
  check?: string;
  details?: string;
}

export interface BankList {
  image: string;
  bankName: string;
}

export interface SelectAccount {
  icon: string;
  title: string;
}

export interface VariationBox {
  title: string;
  details: string;
}

//Form Widgets
export interface VariationSwitch {
  id: number;
  class?: string;
  on?: string;
  off?: string;
  text: string;
  color?: string;
}
